import { cn } from '@workspace/ui/lib/utils'
import { ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { Prose } from '../../components/prose'
import type { CategoryFinding } from '../types'

const DOT_COLOR = {
  strength: 'bg-emerald-400',
  concern: 'bg-red-400',
} as const

export function FindingRow({ finding }: { finding: CategoryFinding }) {
  const [open, setOpen] = useState(false)

  return (
    <div>
      <button
        type="button"
        className="flex w-full items-start gap-2 rounded-md bg-zinc-800/50 px-2.5 py-2 text-left transition-colors hover:bg-zinc-800/80"
        onClick={() => setOpen(!open)}
      >
        <span
          className={cn('mt-[7px] size-[7px] shrink-0 rounded-full', DOT_COLOR[finding.type])}
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="flex-1 text-xs leading-snug text-muted-foreground">
              {finding.text}
            </span>
            <ChevronRight
              className={cn(
                'size-3.5 shrink-0 text-muted-foreground/30 transition-transform',
                open && 'rotate-90'
              )}
            />
          </div>
          {finding.actionHint && !open && (
            <p className="mt-1 text-[11px] font-medium text-[#f97316]">+ {finding.actionHint}</p>
          )}
        </div>
      </button>
      {open && (
        <div className="px-2.5 pt-1.5 pb-3 pl-[23px]">
          <Prose className="text-[11px] leading-relaxed text-muted-foreground/60">
            {finding.detail}
          </Prose>
          {finding.actionHint && (
            <p className="mt-1.5 text-[11px] font-medium text-[#f97316]">+ {finding.actionHint}</p>
          )}
        </div>
      )}
    </div>
  )
}
